import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {IoClose} from "react-icons/io5";
import {SIZES, VISIBLE_TIME_OUT} from "../constants/index.js";
import {useStore} from "@/store/index.jsx";

const Modal = observer(({className}) => {
    const {modalStore} = useStore();
    const handleCloseModal = (idx) => {
        if (modalStore.MODAL_INIT_OPENED[idx]) {
            if (modalStore.MODAL_INIT_OPENED[idx].closeFunc) {
                modalStore.MODAL_INIT_OPENED[idx].closeFunc(modalStore.pop.bind(modalStore));
            } else {
                modalStore.pop();
            }
        }
    };
    const currentModal = useRef([]);
    return (
        <ModalContainerWrapper>
            {
                modalStore.MODAL_INIT_OPENED.length > 0 &&
                modalStore.MODAL_INIT_OPENED.map((item, idx) => (
                    <ModalWrapInner
                        key={idx}
                        ref={(el) => currentModal.current[idx] = el}
                        className={`${item.isFirst ? 'on' : ''} ${item.visible ? "active" : ""} ${item.modalProps.homePageInner ? "homepage-page" : ""}`}
                    >
                        <Dimmer className={`${className} modal-dimmer`} onClick={() => {handleCloseModal(idx)}} />
                        <ModalContainer
                            className={`modal-container ${item.modalProps.subType === "news" ? "news" : ""}`}
                            $width={item.modalProps.width}
                            $height={item.modalProps.height}
                            $transition={VISIBLE_TIME_OUT}
                            $visible={item.modalProps.visible}
                            $moWidth={item.modalProps.moWidth}
                            $moHeight={item.modalProps.moHeight}
                            $maxHeight={item.modalProps.maxHeight}
                        >
                                <ModalTitleWrap $width={item.modalProps.width} className={`${item.modalProps.subType === "news" ? "news" : ""} ${!item.title ? "only" : ""}`}>
                                    <h1>
                                        {item.title}
                                    </h1>
                                    {
                                        item.modalProps.subType !== "news" &&
                                        <button onClick={() => {
                                            handleCloseModal(idx)
                                        }}>
                                            <IoClose color={`${!item.modalProps.closeCustom ? "#22448A" : "#333"}`} size={25}/>
                                        </button>
                                    }
                                </ModalTitleWrap>
                                <item.component
                                    handleCloseModal={handleCloseModal}
                                    modalDepth={idx}
                                    confirmFunc={() => {
                                            item.confirmFunc(() => handleCloseModal(idx));
                                        }}
                                        {...item.modalProps}
                                />
                        </ModalContainer>
                    </ModalWrapInner>
                ))
            }

        </ModalContainerWrapper>
    );
//};
});
const ModalContainerWrapper = styled.div`
    display: block;
`
const ModalContainer = styled.article`
    
    width: ${(props) => (props.$width ? `${props.$width}px` : "auto")};
    height: ${(props) => (props.$height ? props.$height : "auto")};
    position: relative;
    
    z-index: 110;
    transition: ${(props) => `all ${props.$transition/1000}s ease-in-out`};
    overflow: ${(props) => (props.$visible ? "visible" : "hidden")};
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.08), 0px 4px 16px -4px rgba(0, 0, 0, 0.2);
    opacity: 0;
    padding: ${({ theme }) => `${theme.SIZE.MODAL.padding}px`};
    background-color: #fff;
    border-radius: 20px;
    max-height: ${(props) => (props.$maxHeight ? props.$maxHeight : "auto")};
    &.news{
        .news-body{
            margin-top: 72px;
            padding: 0;
            overflow: hidden;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        width: ${(props) => (props.$moWidth ? "calc(100% - 45px)" : `${props.$width}px`)};
        height: ${(props) => (props.$moHeight ? "calc(100vh - 250px)" : `${props.$height}px`)};
        &.news{
            width: calc(100% - 30px);
            .news-body{
                margin-top: 20px;
            }
        }
    }
    
`;

const Dimmer = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.1s ease;
    opacity: 0;
    visibility: hidden;
`;
const ModalWrapInner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 110;
    &.on {
        z-index: 1000;
    }
    &.active{
        .modal-dimmer{
            opacity: 1;
            visibility: visible;   
        }
        .modal-container{
            //transform: translateY(0);
            opacity: 1;
        }
    }
    &.homepage-page{
        top: -96px;
        height: calc((var(--vh) * 100));
    }
    @media (max-width: ${SIZES.TABLET}) {
        &.homepage-page {
            top: -64px;
        }
    }
`;


const ModalTitleWrap = styled.div`
    width: ${({ $width, theme }) => $width ? `${$width - (theme.SIZE.MODAL.padding * 2)}px` : "auto"};
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ theme }) => theme.SIZE.MODAL.head.height};
    &.only{
        height: 24px;
    }
    h1 {
        color: ${({ theme }) => theme.COLORS.MODAL.head.font};
        font-size: ${({ theme }) => theme.SIZE.MODAL.head.font};
        font-weight: ${({ theme }) => theme.SIZE.MODAL.head.weight};
    }
    button{
        position: absolute;
        top: 0;
        right: 0;
        width: ${({ theme }) => theme.SIZE.MODAL.head.close.width};
        height: ${({ theme }) => theme.SIZE.MODAL.head.close.height};
    }
    @media (max-width: ${SIZES.TABLET}) {
        width: auto;
        height: auto;
        position: relative;
        h1{
            font-size: 20px;
        }
        .news{
            height: 46px;
        }
    }
`;
export const ModalBody = styled.div`
    height: calc(100% - ${({ theme }) => theme.SIZE.MODAL.head.height});
    margin-top: ${({ theme }) => theme.SIZE.MODAL.head.height};
    padding: 20px;
    overflow: auto;
    position: relative;
    &.coop{
        height: calc(100% - 24px);
        margin-top: 24px;
        padding: 0 5px 0 5px;
    }
    @media (max-width: ${SIZES.TABLET}) {
        margin: 0;
        padding: 20px 15px 30px;
        height: 100%;
        &.coop{
            height: calc(100% - 48px);
            padding: 0 5px 0;
        }
    }
    &.hidden{
        overflow: hidden;
    }
    &.visible{
        overflow: visible;
    }
`;
export default Modal;
